import { IVehicleModels } from '@common';
import { IVehicleModel } from '@components/sales/sales-vehicle-picker-page';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VehicleModelsState {
  vehicleModels: IVehicleModels;
  vehicleModelData: IVehicleModel[];
}

const initialState: VehicleModelsState = {
  vehicleModels: null,
  vehicleModelData: [],
};

const vehicleModelsSlice = createSlice({
  name: 'vehicleModels',
  initialState,
  reducers: {
    setVehicleModels: (state, action: PayloadAction<IVehicleModels>) => {
      state.vehicleModels = action.payload;
    },
    setVehicleModelData: (state, action: PayloadAction<IVehicleModel[]>) => {
      state.vehicleModelData = action.payload;
    },
  },
});

export const { setVehicleModels, setVehicleModelData } = vehicleModelsSlice.actions;
export default vehicleModelsSlice.reducer;
